import React, { useContext } from "react";
import InterestListContext from "../../contexts/InterestListContext";
import DocsFormatter from "./DocsFormatter";
import InterestListActionsFormatter from "./InterestListActionsFormatter";
import PlayerLinkFormatter from "../table/PlayerLinkFormatter";
import PropTypes from "prop-types";
import EligibleFormatter from "./EligibleFormatter";
import InterestListPositionsFormatter from "./InterestListPositionsFormatter";
import { sortPlayers } from "../roster/RosterSortHelper";
import PastWbcFormatter from "./PastWbcFormatter";
import TableSortFilterContext from "../../contexts/TableSortFilterContext";
import CheckMarkFormatter from "../elements/CheckMarkFormatter";
import ClubFormatter from "../table/ClubFormatter";
import WBCDataTable from "../data-table/WBCDataTable";
import OrgNameFormatter from "../elements/OrgNameFormatter";
import PositionKeyIcon from "../elements/PositionKeyIcon";
import useHasNonCurrentYearAccess from "../hooks/useHasNonCurrentYearAccess";

const columns = [
  {
    key: "actions",
    name: " ",
    sortable: false,
    width: 25,
    formatter: InterestListActionsFormatter
  },
  {
    key: "lastName",
    name: "Last",
    sortable: true,
    width: 120,
    formatter: PlayerLinkFormatter
  },
  {
    key: "firstName",
    name: "First",
    sortable: true,
    width: 120,
    formatter: PlayerLinkFormatter
  },
  {
    key: "pos",
    name: (
      <>
        Pos <PositionKeyIcon tableHeader />
      </>
    ),
    sortable: true,
    width: 125,
    formatter: InterestListPositionsFormatter
  },
  {
    key: "pastWbcFlag",
    name: "Past WBC",
    sortable: true,
    width: 100,
    formatter: PastWbcFormatter
  },
  {
    key: "hasDocuments",
    name: "Docs",
    sortable: true,
    formatter: DocsFormatter,
    width: 80
  },
  {
    key: "eligible",
    name: "Eligibility",
    sortable: true,
    formatter: EligibleFormatter,
    width: 120
  },
  {
    key: "org",
    name: "Org",
    sortable: true,
    width: 65,
    formatter: OrgNameFormatter
  },
  {
    key: "club",
    name: "Club",
    sortable: true,
    width: 250,
    formatter: ClubFormatter
  },
  {
    key: "ilFlag",
    name: "IL",
    sortable: true,
    width: 40,
    formatter: CheckMarkFormatter
  },
  {
    key: "fortyMan",
    name: "40-man",
    sortable: true,
    formatter: CheckMarkFormatter
  }
];

const noDocsColumns = columns.filter(({ key }) => key !== "hasDocuments");

const InterestListTable = ({ data }) => {
  // context(s) and state
  const interestListContext = useContext(InterestListContext);
  const tableSortFilterContext = useContext(TableSortFilterContext);
  const hasNonCurrentYearAccess = useHasNonCurrentYearAccess();

  // variable(s)
  const { players, sortFilters } = interestListContext.state;

  return (
    <div className="row">
      <div className="col-12 full-page-table dropdown-table">
        <WBCDataTable
          useBCR
          enableCellSelect
          enableRowSelect={null}
          rowScrollTimeout={null}
          id="interest-list-table"
          data={data}
          columns={hasNonCurrentYearAccess ? columns : noDocsColumns}
          minColumnWidth={100}
          sortFunc={(col, dir) => {
            interestListContext.dispatch({
              col,
              dir,
              type: "sortPlayers",
              players: sortPlayers(col, dir, players)
            });
            tableSortFilterContext.dispatch({
              type: "setSortFilters",
              sortFilters: { col, dir }
            });
          }}
          sortColumn={sortFilters.col}
          sortDirection={sortFilters.dir}
        />
      </div>
    </div>
  );
};

InterestListTable.propTypes = {
  data: PropTypes.array
};

export default InterestListTable;
